import {createContext, useContext} from 'react'
import {createContextualCan} from './libs/react-ability'

export const AbilityContext = createContext();
export const Can = createContextualCan(AbilityContext.Consumer);

export const useAbility = (...params)=>{
    const ability = useContext(AbilityContext);
    return ability.can(...params);
}